import type {ReactNode} from 'react'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS} from '@contentful/rich-text-types'
import type {Document} from '@contentful/rich-text-types'

export const codeMarkRenderer = {
  [MARKS.CODE]: (children: ReactNode) => <code>{children}</code>,
}

export const noCodeMarkRenderer = {
  [MARKS.CODE]: (children: ReactNode) => children,
}

/**
 * Renders the first paragraph node of a Contentful RichText document with optional inline code mark support.
 * All other nodes are silently ignored to enforce single-line content.
 * Used for headingRich fields (Card, CTABanner, River) and description fields (Hero, CTABanner).
 *
 * @param document - The Contentful rich text document to render
 * @param enableCodeBlocks - Whether to enable code block rendering (controlled by contentful_primer_code_blocks feature flag)
 */
export function renderSingleLineRichText(document: Document, enableCodeBlocks = false): ReactNode {
  const firstParagraph = document.content.find(node => node.nodeType === BLOCKS.PARAGRAPH)
  const singleParagraphDoc: Document = {
    ...document,
    content: firstParagraph ? [firstParagraph] : [],
  }
  return documentToReactComponents(singleParagraphDoc, {
    renderMark: enableCodeBlocks ? codeMarkRenderer : noCodeMarkRenderer,
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
    },
  })
}
